import { Action } from 'redux'
import { IEvent } from '../../models/Event'
import { EventPdfActions } from '../../reducers/events/actionNames'

export interface IRequestEventPdf extends Action {
  eventId: IEvent['id']
}

export interface IRequestEventPdfSuccess extends Action {
  pdf: string
}

export interface IRequestEventPdfFailure extends Action {
  errMessage: string
}

export const requestEventPdf = (eventId: IEvent['id']): IRequestEventPdf => ({
  eventId,
  type: EventPdfActions.EventPdfRequest,
})
export const requestEventPdfSuccess = (
  pdf: string,
): IRequestEventPdfSuccess => ({
  pdf,
  type: EventPdfActions.EventPdfRequestSuccess,
})
export const requestEventPdfFailure = (
  errMessage: string,
): IRequestEventPdfFailure => ({
  errMessage,
  type: EventPdfActions.EventPdfRequestFailure,
})
export const clearPdf = () => ({
  type: EventPdfActions.ClearPdf,
})
